module.exports = __webpack_public_path__ + "static/media/Paloma Ave, Burlingame, CA5.f115f262.jpg";